import { render, staticRenderFns } from "./contactStub.vue?vue&type=template&id=499a319e&"
import script from "./contactStub.vue?vue&type=script&lang=ts&"
export * from "./contactStub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports